const RUNTIME_ENV_CONSTANT = '__ENV' as const;

export { RUNTIME_ENV_CONSTANT };
